import { Routes } from '@angular/router';
import { authGuard } from './auth/auth.guard';

export const routes: Routes = [
    {
      path: 'auth',
      loadComponent: () => import('./auth/auth.component').then((m) => m.AuthComponent),
      title: 'Autenticar'
    },
    {
      path: 'home',
      loadComponent: () => import('./home/home.component').then((m) => m.HomeComponent),
      title: 'DMAnalytics - Home',
      canActivate: [authGuard]
    },
    {
      path: 'dashboard',
      loadComponent: () => import('./dashboard/dashboard.component').then((m) => m.DashboardComponent),
      title: 'Dashboard',
      canActivate: [authGuard]
    },
    {
      path: 'logout',
      loadComponent: () => import('./auth/logout/logout.component').then((m) => m.LogoutComponent),
      title: 'Logout'
    },
    {
      path: 'relatorio2',
      loadComponent: () => import('./relatorio/relatorio.component').then((m) => m.RelatorioComponent),
      title: 'Relatorio',
      canActivate: [authGuard]
    },
    {
      path: 'login-failed',
      loadComponent: () => import('./auth/login-failed/login-failed.component').then((m) => m.LoginFailedComponent),
      title: 'Login Fail'
    },
    {
      path: 'webapi',
      loadComponent: () => import('./webapi/webapi.component').then((m) => m.WebapiComponent),
      title: 'Area Segura',
      canActivate: [authGuard]
    },
    {
      path: 'user_preferences',
      loadComponent: () => import('./alterar-usuario/alterar-usuario.component').then((m) => m.UserProfileComponent),
      title: 'User Preferences',
      canActivate: [authGuard]
    },
    {
      path: 'workspace',
      loadComponent: () => import('./dmdi/workspace/workspace.component').then((m) => m.WorkspaceComponent),
      title: 'Workspace',
      canActivate: [authGuard]
    },
    {
      path: 'project',
      loadComponent: () => import('./dmdi/project/project.component').then((m) => m.ProjectComponent),
      title: 'Project',
      canActivate: [authGuard]
    },
    {
      path: 'connection',
      loadComponent: () => import('./dmdi/connection/connection.component').then((m) => m.ConnectionComponent),
      title: 'Connection',
      canActivate: [authGuard]
    },
    {
      path: 'action',
      loadComponent: () => import('./dmdi/actions/actions.component').then((m) => m.ActionsComponent),
      title: 'Action',
      canActivate: [authGuard]
    },
    {
      path: 'dataquality',
      loadComponent: () => import('./dmdi/data-quality/data-quality.component').then((m) => m.DataQualityComponent),
      title: 'Data Quality',
      canActivate: [authGuard]
    },
    {
      path: 'data-lineage',
      loadComponent: () => import('./components/data-lineage/data-lineage.component').then((m) => m.DataLineageComponent),
      title: 'Data Lineage'
    },
    {
      // Estado da tela na rota: `code` no caminho, `direction` e `depth` na
      // query - o link sozinho reproduz o grafo que o outro esta vendo.
      path: 'data-lineage/:code',
      loadComponent: () => import('./components/data-lineage/data-lineage.component').then((m) => m.DataLineageComponent),
      title: 'Data Lineage'
    },
    // Caminho antigo, mantido porque existe link salvo por ai.
    { path: 'datalineage', redirectTo: 'data-lineage', pathMatch: 'full' },
    { path: 'datalineage/:code', redirectTo: 'data-lineage/:code' },
    {
      path: 'datacatalog',
      loadComponent: () => import('./dmdi/data-catalog/data-catalog.component').then((m) => m.DataCatalogComponent),
      title: 'Data Catalog',
      canActivate: [authGuard]
    },
    {
      path: 'instance',
      loadComponent: () => import('./dmdi/instance/instance.component').then((m) => m.InstanceComponent),
      title: 'Instancia',
      canActivate: [authGuard]
    },
    {
      path: 'schedule',
      loadComponent: () => import('./dmdi/schedule/schedule.component').then((m) => m.ScheduleComponent),
      title: 'Schedule',
      canActivate: [authGuard]
    },
    {
      path: 'workload',
      loadComponent: () => import('./dmdi/workload/workload.component').then((m) => m.WorkloadComponent),
      title: 'Carga de Trabalho',
      canActivate: [authGuard]
    },
    {
      path: 'execution',
      loadComponent: () =>
        import('./dmdi/execution-monitor/execution-monitor.component').then((m) => m.ExecutionMonitorComponent),
      title: 'Execução',
      canActivate: [authGuard]
    },
    {
      path: 'errors',
      loadComponent: () => import('./components/error-page/error-page.component').then((m) => m.ErrorPageComponent),
      title: 'Erros e Avisos'
    },
    {
      path: '',
      redirectTo: 'home',
      pathMatch: 'full',
      title: 'DMAnalytics'
    },
    {
      path: '**',
      redirectTo: 'home',
      title: 'DMAnalytics'
    }
  ];